module.exports = __webpack_public_path__ + "6e83d4bf38a9d2c2f9089aa3cbff5bce.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarArabella2.png
// module id = 22
// module chunks = 0